<template>
  <payment-template>
    <base-header
      slot="header"
      :title="$t('content.returned.title')"
      :language="getLanguage"
    />
    <access-denied
      slot="content"
      :title="$t('content.returned.message')"
    />
  </payment-template>
</template>

<script>
import { mapGetters } from 'vuex';

import AccessDenied from 'molecules/common/AccessDenied';
import BaseHeader from 'organisms/base/BaseHeader';
import PaymentTemplate from 'templates/PaymentTemplate';

export default {
  name: 'ContentReturned',
  components: {
    AccessDenied,
    BaseHeader,
    PaymentTemplate,
  },
  computed: {
    ...mapGetters([
      'getLanguage',
    ]),
  },
};
</script>
